var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.256165 17.709C0.256165 14.0271 3.24093 11.0423 6.92283 11.0423C10.6047 11.0423 13.5895 14.0271 13.5895 17.709H11.9228C11.9228 14.9476 9.68425 12.709 6.92283 12.709C4.16141 12.709 1.92283 14.9476 1.92283 17.709H0.256165ZM6.92283 10.209C4.16033 10.209 1.92283 7.97148 1.92283 5.20898C1.92283 2.44648 4.16033 0.208984 6.92283 0.208984C9.68533 0.208984 11.9228 2.44648 11.9228 5.20898C11.9228 7.97148 9.68533 10.209 6.92283 10.209ZM6.92283 8.54232C8.7645 8.54232 10.2562 7.05065 10.2562 5.20898C10.2562 3.36732 8.7645 1.87565 6.92283 1.87565C5.08116 1.87565 3.5895 3.36732 3.5895 5.20898C3.5895 7.05065 5.08116 8.54232 6.92283 8.54232Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.6842ed68d8c8388cd2d5181454d82de5.svg";
export { ForwardRef as ReactComponent };